<template>
  <div class="telegram-bot-error">
    <ErrorIcon class="telegram-bot-error__icon" />
    <p class="telegram-bot-error__message">{{ message }}</p>
    <OrangeFancyButton class="telegram-bot-error__retry" @click="$emit('retry')">
      Спробувати ще раз
    </OrangeFancyButton>
  </div>
</template>

<script>
import { OrangeFancyButton } from '@/shared/ui/form';
import { ErrorIcon } from '@/shared/ui/icons';

export default {
  components: { OrangeFancyButton, ErrorIcon },
  props: {
    message: {
      type: String,
      default: 'Щось пішло не так.',
    },
  },
};
</script>

<style lang="scss" scoped>
.telegram-bot-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 340px;
  margin: 0 auto;

  &__icon {
    transform: scale(3);
    margin-bottom: 24px;
  }

  &__message {
    font-size: 14px;
    color: #71717A;
    margin-bottom: 16px;
  }

  &__retry {
    width: auto;
  }
}
</style>
